<template>
  <v-switch
    v-model="internalValue"
    :label="text"
    @change="emitChange"
    :inset="isInset"
    :disabled="disabled"
    :false-value="falseValue"
    :true-value="trueValue"
    color="primary"
  ></v-switch>
</template>

<script>
export default {
  name: "BaseSwitchButton",
  props: {
    value: {
      type: [Boolean, Number], // Allow both types for flexibility
      required: true,
    },
    text: {
      required: true,
      type: String,
    },
    isInset: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    falseValue: {
      required: false,
      type: [Boolean, Number],
      default: 0,
    },
    trueValue: {
      required: false,
      type: [Boolean, Number],
      default: 1,
    },
  },
  data() {
    return {
      internalValue: this.value, // Local state synced with `value`
    };
  },
  methods: {
    emitChange(newVal) {
      this.internalValue = newVal; // Update local state
      this.$emit("input", newVal); // Emit to parent for two-way binding
    },
  },
  watch: {
    // Watch prop change and update local state
    value(newVal) {
      // console.log("emitChange", newVal);
      this.internalValue = newVal;
    },
  },
};
</script>

<style scoped>
.v-input.v-input--is-disabled .v-input__control .v-input__slot {
  background-color: white !important;
}
</style>
